<template>
	<b-col cols="12" class="mt-4">
		<component :is="typeRow" b-row v-for="row in rowItens" v-bind:key="hashObject(row)">
			<!-- TODO não usar "field.name" como id, pois ele é repetido em alguns componentes -->
			<b-col
				v-for="field in getFieldsByRow(row)"
				v-bind:key="hashObject(field.id)"
				:id="field.name"
				cols="12"
				:md="field.width"
				:class="{
					dispNone: field.isVisible != undefined ? !field.isVisible : false,
					fieldSpace: field.space != undefined ? field.space : false,
					fieldSize: field.size != undefined ? field.size : false
				}"
			>
				<b-form v-on:submit.prevent>
					<b-form-group
						:class="[{ lowerLabel: field.lowerLabel != undefined ? field.lowerLabel : false }, field.labelClass || '']"
						style="overflow-wrap: break-word"
						:label="field.type === 'checkbox' ? '' : field.label"
						:label-for="field.id"
					>
						<k-input
							v-if="field.type === 'text' || field.type === 'number' || field.type === 'search'"
							:ref="field.name"
							:class="field.class"
							:min="field.min"
							:max="field.max"
							:maxlength="field.maxlength"
							:minlength="field.minlength"
							:fieldInfo="field"
							:value="data[field.name]"
							v-model="data[field.name]"
							:state="validation[field.name]"
							:errors="errors"
							:isActive="isActive(field)"
							@blur="handleBlur"
							@change="fieldChange"
							:aria-describedby="`${field.name}-feedback`"
							:disabled="field.disabled"
							:customMask="field.customMask"
							:formatter="field.formatter"
							:textCasing="field.textCasing"
							:allowedChar="field.allowedChar"
							@enterPress="field.enterPress"
							@keyDownPress="keyDownPress"
							:toUpperCase="field.upperCaseValue ?? $functions.readUpperCaseStorageConfig()"
						/>

						<k-password
							v-if="field.type === 'password'"
							:ref="field.name"
							:class="field.class"
							:fieldInfo="field"
							:value="data[field.name]"
							v-model="data[field.name]"
							:state="validation[field.name]"
							:errors="errors"
							:isActive="isActive(field)"
							@blur="handleBlur"
							@change="fieldChange"
							:aria-describedby="`${field.name}-feedback`"
							:disabled="field.disabled"
							v-mask="field.mask"
							@enterPress="field.enterPress"
						/>

						<k-monetary
							v-if="field.type === 'monetary'"
							@blur="handleBlur"
							@change="fieldChange"
							v-model="data[field.name]"
							:value="data[field.name]"
							:fieldInfo="field"
							:disabled="field.disabled"
							:state="validation[field.name]"
						/>

						<k-select
							v-if="field.type === 'dropdown'"
							:ref="field.name"
							:key="(field.options || []).map((o) => o.value).join('-')"
							:options="field.options"
							v-model="data[field.name]"
							:valueKey="field.valueKey"
							:valueText="field.valueText"
							:returnKey="field.returnKey"
							:state="validation[field.name]"
							:errors="errors"
							:name="field.name"
							:placeholder="field.placeholder"
							@blur="handleBlur"
							@change="fieldChange"
							:isActive="isActive(field)"
							:aria-describedby="`${field.name}-feedback`"
						/>

						<k-select-question
							v-if="field.type === 'dropdownResponse'"
							:ref="field.name"
							:key="(field.options || []).map((o) => o.value).join('-')"
							:options="field.options"
							v-model="data[field.name]"
							:valueKey="field.valueKey"
							:valueText="field.valueText"
							:returnKey="field.returnKey"
							:state="validation[field.name]"
							:errors="errors"
							:name="field.name"
							:placeholder="field.placeholder"
							@blur="handleBlur"
							@change="fieldChange"
							:isActive="isActive(field)"
							:aria-describedby="`${field.name}-feedback`"
						/>

						<k-checkbox
							v-if="field.type === 'checkbox'"
							:ref="field.name"
							:state="validation[field.name]"
							:name="field.name"
							:type="field.type"
							:errors="errors"
							:label="field.label"
							v-model="data[field.name]"
							:isActive="isActive(field)"
							@checkChange="checkChange"
							:id="field.id"
							:aria-describedby="`${field.name}-feedback`"
						/>

						<k-checkbox-group
							v-if="field.type === 'checkboxGroup'"
							:ref="field.name"
							:disabled="field.disabled"
							:field="field"
							:isActive="isActive(field)"
							v-model="data[field.name]"
							@checkChange="checkChange"
						/>

						<k-dropdown-checkbox
							v-if="field.type === 'dropdownCheckbox'"
							:ref="field.name"
							:text="field.text"
							:name="field.name"
							:entityList="field.entityList"
							:errors="errors"
							@checkChange="checkChange"
							:isActive="isActive(field)"
						/>

						<k-switch
							v-if="field.type === 'switch'"
							:class="field.class"
							:ref="field.name"
							v-model="data[field.name]"
							:errors="errors"
							:fieldInfo="field"
							:state="validation[field.name]"
							:isActive="isActive(field)"
							@change="fieldChange"
						/>

						<k-radio
							v-if="field.type === 'radio'"
							:ref="field.name"
							:errors="errors"
							:class="field.class"
							:radios="field.radios"
							:isActive="isActive(field)"
							v-model="data[field.name]"
							:state="validation[field.name]"
							:selected="field.selected ? field.selected : data[field.name]"
							:name="field.name"
							:field="field"
							@onChange="fieldChange"
							:aria-describedby="`${field.name}-feedback`"
							:disabled="field.disabled"
						/>

						<k-radio-button
							v-if="field.type === 'radioButton'"
							:ref="field.name"
							:options="field.options"
							v-model="data[field.name]"
							:isActive="isActive(field)"
							:state="validation[field.name]"
							:errors="errors"
							:aria-describedby="`${field.name}-feedback`"
						/>

						<k-radio-suggestions
							v-if="field.type === 'radioSuggestions'"
							:ref="field.name"
							:options="field.options"
							v-model="data[field.name]"
							:data="data"
							:isActive="isActive(field)"
							:name="field.name"
							:state="validation[field.name]"
							:errors="errors"
							@change="fieldChange"
							:aria-describedby="`${field.name}-feedback`"
						/>

						<k-select-suggestions
							v-if="field.type === 'suggestionSelect'"
							:ref="field.name"
							:options="field.options"
							:isActive="isActive(field)"
							v-model="data[field.name]"
						/>

						<k-text-area
							v-if="field.type === 'textArea'"
							:ref="field.name"
							v-model="data[field.name]"
							:name="field.name"
							:minRows="field.minRows"
							:maxRows="field.maxRows"
							:isResizable="field.isResizable"
							:hideOverflow="field.hideOverflow"
							:isActive="isActive(field)"
							:state="validation[field.name]"
							:errors="errors"
							:placeholder="field.placeholder"
							:disabled="field.disabled"
							@change="fieldChange"
							@enterPress="field.enterPress"
							:toUpperCase="field.upperCaseValue ?? $functions.readUpperCaseStorageConfig()"
							:formatter="field.formatter"
							:textCasing="field.textCasing"
							:allowedChar="field.allowedChar"
						/>

						<k-search
							v-if="field.type === 'Search' || field.type === 'SearchList'"
							:ref="field.name"
							:type="field.type"
							:isList="field.isList"
							:options="field.options"
							v-model="data[field.name]"
							:data="data"
							:name="field.name"
							:state="validation[field.name]"
							:errors="errors"
							:aria-describedby="`${field.name}-feedback`"
							:isActive="isActive(field)"
						/>

						<k-input-file
							v-if="field.type === 'InputFile'"
							:ref="field.name"
							v-model="data[field.name]"
							:fieldInfo="field"
							:state="validation[field.name]"
							:errors="errors"
							:aria-describedby="`${field.name}-feedback`"
							:isActive="isActive(field)"
							@change="fieldChange"
							@fileChange="emitFileChange"
						/>

						<k-input-file-new
							v-if="field.type === 'InputFileNew'"
							:ref="field.name"
							v-model="data[field.name]"
							:fieldInfo="field"
							:state="validation[field.name]"
							:errors="errors"
							:aria-describedby="`${field.name}-feedback`"
							:isActive="isActive(field)"
							@change="fieldChange"
							@fileChange="emitFileChange"
						/>

						<k-date-picker
							v-if="field.type === 'datePicker'"
							:ref="field.name"
							:key="hashObject(data[field.name])"
							v-model="data[field.name]"
							:errors="errors"
							:fieldInfo="field"
							:state="validation[field.name]"
							:isActive="isActive(field)"
							:name="field.name"
							@change="fieldChange"
						/>

						<k-list-options
							v-if="field.type === 'listOptions'"
							:ref="field.name"
							:key="hashObject(data[field.name])"
							:fieldInfo="field"
							:value="data[field.name]"
							v-model="data[field.name]"
							:state="validation[field.name]"
							:errors="errors"
							:isActive="isActive(field)"
							@change="fieldChange"
							:aria-describedby="`${field.name}-feedback`"
						/>

						<k-multi-select
							v-if="field.type === 'multiSelect'"
							:ref="field.name"
							:fieldInfo="field"
							v-model="data[field.name]"
							:state="validation[field.name]"
							:errors="errors"
							:isActive="isActive(field)"
							@change="fieldChange"
							:aria-describedby="`${field.name}-feedback`"
						/>

						<k-question-checkbox-group
							v-if="field.type === 'questionCheckboxGroup'"
							:ref="field.name"
							:key="hashObject(data[field.name])"
							:fieldInfo="field"
							:alternatives="data[field.name]"
							:state="validation[field.name]"
							:errors="errors"
							:isActive="isActive(field)"
							@change="fieldChange"
							@openAlternativeCondition="$emit('openAlternativeCondition', $event)"
							:aria-describedby="`${field.name}-feedback`"
							:toUpperCase="field.upperCaseValue ?? $functions.readUpperCaseStorageConfig()"
							:lockedFields="field.lockedFields"
						/>

						<k-question-checkbox-group-view
							v-if="field.type === 'questionCheckboxGroupView'"
							:ref="field.name"
							:key="hashObject(data[field.name])"
							:fieldInfo="field"
							:alternatives="data[field.name]"
							:state="validation[field.name]"
							:errors="errors"
							:isActive="isActive(field)"
							@change="fieldChange"
							:aria-describedby="`${field.name}-feedback`"
						/>

						<k-question-radio-group
							v-if="field.type === 'questionRadioGroup'"
							:ref="field.name"
							:key="hashObject(data[field.name])"
							:fieldInfo="field"
							:alternatives="data[field.name]"
							:state="validation[field.name]"
							:errors="errors"
							:isActive="isActive(field)"
							@change="fieldChange"
							@openAlternativeCondition="$emit('openAlternativeCondition', $event)"
							:aria-describedby="`${field.name}-feedback`"
							:toUpperCase="field.upperCaseValue ?? $functions.readUpperCaseStorageConfig()"
							:lockedFields="field.lockedFields"
						/>

						<k-question-radio-group-view
							v-if="field.type === 'questionRadioGroupView'"
							:ref="field.name"
							:key="hashObject(data[field.name])"
							:fieldInfo="field"
							:alternatives="data[field.name]"
							:state="validation[field.name]"
							:errors="errors"
							:isActive="isActive(field)"
							@change="fieldChange"
							:aria-describedby="`${field.name}-feedback`"
						/>

						<k-button
							v-if="field.type === 'button'"
							:ref="field.name"
							:key="hashObject(data[field.name])"
							:fieldInfo="field"
							:isActive="isActive(field)"
							:variant="field.variant"
							:text="field.title"
							:class="field.class"
							:style="field.style"
							@click="handleOnClick(field.name)"
						/>

						<div v-if="field.type === 'filler'"></div>

						<slot name="customField" v-if="field.type === 'customField'"></slot>
					</b-form-group>
				</b-form>
			</b-col>
		</component>
	</b-col>
</template>

<script>
import KSelectSuggestions from "./FormComponents/KSelectSuggestions.vue";
import KCheckbox from "./FormComponents/KCheckbox.vue";
import KCheckboxGroup from "./FormComponents/KCheckboxGroup.vue";
import KInput from "./FormComponents/KInput.vue";
import KSelect from "./FormComponents/KSelect.vue";
import KRadio from "./FormComponents/KRadio.vue";
import KRadioButton from "./FormComponents/KRadioButton.vue";
import KTextArea from "./FormComponents/KTextArea.vue";
import KRadioSuggestions from "./FormComponents/KRadioSuggestions.vue";
import KSearch from "./FormComponents/KSearch.vue";
import KDatePicker from "./FormComponents/KDatePicker.vue";
import KInputFile from "./FormComponents/KInputFile.vue";
import KInputFileNew from "./FormComponents/KInputFileNew.vue";
import KListOptions from "./FormComponents/KListOptions.vue";
import KMultiSelect from "./FormComponents/KMultiselect.vue";
import KSwitch from "./FormComponents/KSwitch.vue";
import KDropdownCheckbox from "./FormComponents/KDropdownCheckbox.vue";
import KQuestionCheckboxGroup from "./FormComponents/KQuestionCheckboxGroup.vue";
import KQuestionCheckboxGroupView from "./FormComponents/KQuestionCheckboxGroupView.vue";
import KQuestionRadioGroup from "./FormComponents/KQuestionRadioGroup.vue";
import KQuestionRadioGroupView from "./FormComponents/KQuestionRadioGroupView.vue";
import KPassword from "./FormComponents/KPassword.vue";
import KMonetary from "./FormComponents/KMonetary.vue";
import KSelectQuestion from "./FormComponents/KSelectRequirementQuestion.vue";
import KButton from "../ui/Buttons/KButton.vue";

export default {
	components: {
		KRadioSuggestions,
		KInput,
		KSelect,
		KSelectQuestion,
		KCheckbox,
		KCheckboxGroup,
		KRadio,
		KRadioButton,
		KSelectSuggestions,
		KTextArea,
		KSearch,
		KInputFile,
		KInputFileNew,
		KDatePicker,
		KListOptions,
		KMultiSelect,
		KSwitch,
		KDropdownCheckbox,
		KQuestionCheckboxGroup,
		KQuestionCheckboxGroupView,
		KQuestionRadioGroup,
		KQuestionRadioGroupView,
		KPassword,
		KMonetary,
		KButton
	},
	props: {
		fields: {
			type: Array,
			required: true
		},
		data: {
			type: Object
		},
		customFieldConfigs: {
			type: Object
		},
		crudActive: {
			type: Boolean,
			default: true
		},
		notifyOnUpdate: {
			type: Boolean,
			default: false
		},
		concat: {
			type: Boolean,
			default: true
		}
	},
	data: function () {
		let validation = {};
		this.fields.forEach((field) => {
			validation[field.name] = null;
		});
		return { validation };
	},
	computed: {
		rowItens: function () {
			let rows = [];
			let numrows = this.getRowsNum();
			for (let i = 0; i <= numrows; i++) {
				rows.push(i);
			}
			return rows;
		},
		errors: function () {
			let errors = {};
			this.fields.forEach((field) => {
				if (field.validation) {
					errors[field.name] = field.validation.message;
					this.exceptionMessages(field, errors);
				}
			});
			return errors;
		},
		typeRow: function () {
			return this.concat ? "b-form-row" : "b-row";
		}
	},
	methods: {
		keyDownPress(event) {
			this.$emit("keyDownPress", event);
		},
		isActive: function (field) {
			return this.crudActive ? (field.isActive ? field.isActive : true) : false;
		},
		checkChange(name) {
			this.fieldChange(name);
			this.$emit("checkChange", name);
		},
		validateAllFields() {
			let allOk = true;
			this.fields?.forEach((field) => {
				if (field.validation) {
					const isFieldVisible = field.isVisible !== undefined ? field.isVisible : true;
					const fieldRef = this.$refs[field.name] && this.$refs[field.name][0];
					const isFieldActive = fieldRef ? fieldRef.active : false;

					if (!field.validation.rule(this.data[field.name]) && isFieldActive && isFieldVisible) {
						allOk = false;
						console.error(
							`Field ${field.name} was not valid!`,
							this.$refs[field.name][0],
							`Active value: ${this.$refs[field.name][0].active}`
						);
						this.setValidation(true, field);
						return allOk;
					} else {
						this.setValidation(null, field);
					}
				}
			});
			return allOk;
		},
		setValidation: function (isValid, field) {
			if (isValid && field && field.validation) {
				let validate = this.validateState(field.validation, this.data[field.name]);
				this.validation[field.name] = validate;
			}
		},
		cleanValidation: function () {
			this.fields.forEach((field) => {
				this.validation[field.name] = null;
			});
		},
		validateState(func, data) {
			if (func.rule(data)) {
				return true;
			}
			return false;
		},
		getRowsNum: function () {
			let maxRow = 0;
			this.fields.forEach((field) => {
				if (field.rowNum > maxRow) maxRow = field.rowNum;
			});
			return maxRow;
		},
		getFieldsByRow: function (row) {
			return this.fields.filter((field) => field.rowNum == row);
		},
		fieldChange: async function (fieldName) {
			this.setValidation(
				true,
				this.fields.find((field) => field.name == fieldName)
			);
			let childs = this.getFieldChilds(fieldName);
			childs.forEach((child) => {
				let internChild = child[0];
				internChild.parentChanged(this.data[fieldName]);

				let granchilds = this.getFieldChilds(internChild.name);
				granchilds.forEach((granchild) => {
					let internGranchild = granchild[0];
					if (internGranchild && typeof internGranchild.parentChanged == "function") {
						internGranchild.parentChanged(this.data[internChild.name]);
					}
				});
			});
			this.$emit("fieldChange", fieldName);
		},
		handleOnClick: async function (fieldName) {
			this.$emit("handleOnClick", fieldName);
		},
		handleBlur: function (field) {
			this.$emit("blur", field);
		},
		getFieldChilds: function (name) {
			let childs = [];
			this.fields.forEach((field) => {
				if (field.parentName == name) {
					let localRef = this.$refs[field.name];
					if (localRef) {
						childs.push(localRef);
					}
				}
			});
			return childs;
		},

		emitFileChange: function (file) {
			this.$emit("fileChange", file, this.data.scoreId);
		},

		notifyChanges: function () {
			this.fields.forEach((field) => {
				let childs = this.getFieldChilds(field.name);
				childs.forEach((child) => {
					try {
						if (child) {
							let internChild = child[0];
							if (internChild) {
								if (typeof internChild.parentChanged == "function") {
									internChild.parentChanged(this.data[field.name]);
								}
							}
						}
					} catch (err) {
						console.error("child error", err);
					}
				});
			});
		},
		changeValidationByName(name, value, newMessage = null) {
			if (newMessage !== null) {
				this.errors[name] = newMessage;
			}
			this.validation[name] = value;
		},
		changeErrorMessage(name, newMessage) {
			this.errors[name] = newMessage;
		},
		getFieldValidation(name) {
			return [this.validation[name], this.errors[name]];
		},
		exceptionMessages(field, errors) {
			if (field.validation.message === "Usuário já em uso!" && this.data[field.name] === "") {
				errors[field.name] = this.$t("messages.fieldIsMandatory");
			}
		},
		hashObject: function (paramObject) {
			return paramObject;
		}
	},
	watch: {
		fields(newValue) {
			const newValidation = { ...this.validation };
			newValue.forEach((field) => {
				if (!field.validation) {
					newValidation[field.name] = null;
				}
			});
			this.validation = newValidation;
		}
	},
	updated() {
		//Notificar todas as relações quando o componente atualiza
		if (this.notifyOnUpdate) this.notifyChanges();
	},
	mounted() {
		//Notificar todas as relações quando o componente monta
		this.notifyChanges();
	}
};
</script>

<style>
.col-form-label {
	padding-bottom: 8px !important;
	white-space: wrap;
}
.dispNone {
	display: none;
}
.lowerLabel {
	margin-bottom: 8px !important;
}
.lowerLabel legend {
	font-size: 10px;
	color: #666666;
}
.fieldSpace {
	padding-right: 8px !important;
	padding-left: 8px !important;
}
.fieldSize {
	margin-bottom: -8px !important;
	padding-left: 0px;
}
</style>
